<template>
  <v-container class="grey lighten-5" v-if="widget.type==='productList'">
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="4" xl="3" v-for="item in widget.data.rows" :key="item.id + 'product'">
        <product-template2
          :hasCount="parseInt(widget.data.number)!==0"
          :id="parseInt(item.idProduct)"
          :title="item.titleProduct"
          :action="widget.data.action"
          :image="item.imageProduct"
          :price="parseInt(item.priceProduct)"
          :description="item.descriptionProduct"
          :number="parseInt(widget.data.number)"
          :rate="typeof item.rateProduct!=='undefined' ? parseFloat(item.rateProduct) : undefined"
          :off="typeof item.offProduct!=='undefined' ? parseInt(item.offProduct) : undefined"
          :priceWithoutOff="typeof item.priceWithoutOffProduct!=='undefined' ? parseInt(item.priceWithoutOffProduct) : undefined"
          :is-add-to-basket="widget.data.addToBasket"
          @response_handler="responseHandler"
          @on-pagination="onPagination"
          @open-dialog="openDialog"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div style="width: 100%">
          <v-pagination
            v-if="widget.type==='productList' && widget.data.serverPagination===1"
            v-model="widget.data.pagination.current_page"
            :length="widget.data.pagination.last_page"
            :prev-icon="mdiMenuLeft"
            :next-icon="mdiMenuRight"
            circle
            @input="onPagination(widget.data.name,widget.data.pagination.current_page)"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "@axios";
import baseConfig from '@/../baseConfig'
import router from "@/router";
import {
  mdiCheck,
  mdiCheckCircleOutline,
  mdiCreditCard,
  mdiCreditCardCheck, mdiEyeOutline, mdiMenuLeftOutline, mdiMenuRightOutline,
  mdiMinusCircleOutline, mdiPen,
  mdiPlus, mdiTrashCan
} from "@mdi/js";
import goTo from 'vuetify/lib/services/goto'
import TileDefaultTableDesign from "@/views/generator/vueContents/tile/tile-default-table-design";
import TileIconLeftDefaultTableDesign from "@/views/generator/vueContents/tile/tile-icon-left-default-table-design";
import store from "@/store";
import ProductTemplate1 from "@/views/generator/product/product-template1";
import ProductTemplate2 from "@/views/generator/product/product-template2";

export default {
  name: "product-grid1",
  components: {ProductTemplate2, ProductTemplate1},
  props: {
    widget: Object,
    widgets: Array,
    filter: Object
  },
  data() {
    return {
      icons: {
        mdiCheck2: mdiCheck,
        mdiCreditCard: mdiCreditCard,
        mdiPlus: mdiPlus,
        mdiCreditCardCheck: mdiCreditCardCheck,
      },
      editIcon: mdiPen,
      mdiCheck: mdiCheckCircleOutline,
      mdiMinus: mdiMinusCircleOutline,
      deleteIcon: mdiTrashCan,
      mdiDetails: mdiEyeOutline,
      mdiMenuLeft: mdiMenuLeftOutline,
      mdiMenuRight: mdiMenuRightOutline,
    }
  },
  methods: {
    onPagination(name, current) {
      console.log('on tab ran',name, current)
      this.$emit('on-pagination', name, current, this.filter)
    },
    responseHandler(r, refresh = false) {
      this.$emit('response_handler', r, refresh)
    },
    openDialog(dialog, moveBodyToDialog, destinationForm, data) {
      this.$emit('open-dialog', dialog, moveBodyToDialog, destinationForm , data)
    }
  }
}
</script>

<style scoped>

</style>
